console.log("Medicines added")
const Sildenafil = [
    {
      id: 6626280145105,
      mainTitle: "Sildenafil <strong>100mg</strong> Tabs",
      title: "100mg tabs",
      variants: [
        {
          id: 41795213394129,
          product_id: 6626280145105,
          title: "34",
          price: "120.00",
        },
        {
          id: 39672501862609,
          product_id: 6626280145105,
          title: "17",
          price: "65.00",
        },
        {
          id: 39672501895377,
          product_id: 6626280145105,
          title: "10",
          price: "40.00",
        },
      ],
    },
    {
      id: 6568602894545,
      mainTitle: "Sildenafil <strong>20mg</strong> Tabs",
      title: "20mg tabs",
      variants: [
        {
          id: 39672505794769,
          product_id: 6568602894545,
          title: "65",
          price: "125.00",
        },
        {
          id: 39672505827537,
          product_id: 6568602894545,
          title: "34",
          price: "90.00",
        },
        {
          id: 39672505860305,
          product_id: 6568602894545,
          title: "17",
          price: "50.00",
        },
      ],
    },
  ];
  const Tadalafil = [
    {
      title: "20mg Tabs",
      mainTitle: "Tadalafil <strong>20mg</strong> Tabs",
      variants: [
        {
          id: 39672510677201,
          product_id: 6584638734545,
          title: "28",
          price: "120.00",
        },
        {
          id: 39672510709969,
          product_id: 6584638734545,
          title: "14",
          price: "65.00",
        },
        {
          id: 39672510742737,
          product_id: 6584638734545,
          title: "7",
          price: "40.00",
  
          
        },
      ],
    },
    {
      id: 6625705296081,
      title: "5mg Tabs",
      mainTitle: "Tadalafil <strong>5mg</strong> Tabs",
      variants: [
        {
          id: 39672521294033,
          product_id: 6625705296081,
          title: "65",
          price: "125.00",
        },
        {
          id: 39672521326801,
          product_id: 6625705296081,
          title: "28",
          price: "90.00",
        },
        {
          id: 39672521359569,
          product_id: 6625705296081,
          title: "14",
          price: "50.00",
        },
      ],
    },
  ];
  const Sertraline = [
    {
      id: 6629745590481,
      title: "100mg tabs",
      mainTitle: "Sertraline <strong>100mg</strong> Tabs",
      variants: [
        {
          id: 39673502925009,
          product_id: 6629745590481,
          title: "28",
          price: "90.00",
        },
        {
          id: 39673502957777,
          product_id: 6629745590481,
          title: "14",
          price: "50.00",
        },
      ],
    },
    {
      id: 6593491173585,
      title: "50mg tabs",
      mainTitle: "Sertraline <strong>50mg</strong> Tabs",
      variants: [
        {
          id: 39672495374545,
          product_id: 6593491173585,
          title: "28",
          price: "90.00",
        },
        {
          id: 39672495407313,
          product_id: 6593491173585,
          title: "14",
          price: "50.00",
        },
      ],
    },
  ];
  const Finasteride = [
    {
      id: 6593493401809,
      mainTitle: "Finasteride <strong>1mg</strong> Tabs",
      title: "1mg tabs",
      variants: [
        {
          id: 39672491114705,
          product_id: 6593493401809,
          title: "180",
          price: "130.00",
        },
        {
          id: 39672491147473,
          product_id: 6593493401809,
          title: "90",
          price: "75.00",
        },
        {
          id: 39672491213009,
          product_id: 6593493401809,
          title: "30",
          price: "45.00",
        },
      ],
    },
  ];
  const Valacyclovir = [
    {
      id: 6593494221009,
      title: "500 mg Tabs",
      mainTitle: "Valacyclovir <strong>500mg</strong> Tabs",
      variants: [
        {
          id: 39672524439761,
          product_id: 6593494221009,
          title: "90",
          price: "220.00",
        },
        {
          id: 39672524472529,
          product_id: 6593494221009,
          title: "30",
          price: "90.00",
        },
        {
          id: 39672524505297,
          product_id: 6593494221009,
          title: "10",
          price: "40.00",
        },
      ],
    },
  ];
  const Acyclovir = [
    {
      id: 6593495138513,
      title: "800mg Tabs",
      mainTitle: "Acyclovir <strong>800mg</strong> Tabs",
      variants: [
        {
          id: 39672485675217,
          product_id: 6593495138513,
          title: "50",
          price: "90.00",
        },
      ],
    },
  ];